<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    :z-index="drawerZIndex"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item :label="$t('views.settlementPayment.form.settlementId')" prop="settlementId">-->
<!--        <a-input-->
<!--          v-model="form.settlementId"-->
<!--          :disabled="baseFieldsDisabled"-->
<!--          :placeholder="$t('views.settlementPayment.form.settlementIdPlaceholder')"-->
<!--        />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item :label="$t('views.settlementPayment.form.type')" prop="type">-->
<!--        <a-select-->
<!--          v-model="form.type"-->
<!--          :disabled="baseFieldsDisabled"-->
<!--          :placeholder="$t('views.settlementPayment.form.typePlaceholder')"-->
<!--          style="width: 100%"-->
<!--        >-->
<!--          <a-select-option-->
<!--            v-for="opt in paymentTypeOptions"-->
<!--            :key="String(opt.value)"-->
<!--            :value="opt.value"-->
<!--          >-->
<!--            {{ opt.label }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('views.settlementPayment.form.money')" prop="money">
        <a-input
          v-model="form.money"
          :disabled="baseFieldsDisabled"
          :placeholder="$t('views.settlementPayment.form.moneyPlaceholder')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.settlementPayment.form.url')" prop="url">
        <template v-if="baseFieldsDisabled">
          <img
            v-for="(item, index) in urlPreviewList"
            :key="index"
            style="width: 48px;height: 48px;margin-right: 5px;margin-bottom: 5px"
            v-image-preview
            :src="item"
          >
        </template>
        <a-input
          v-else
          v-model="form.url"
          :placeholder="$t('views.settlementPayment.form.urlPlaceholder')"
          type="textarea"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.settlementPayment.form.auditStatus')" prop="auditStatus">
        <a-select
          v-model="form.auditStatus"
          style="width: 100%"
          :placeholder="$t('views.settlementPayment.form.auditStatusPlaceholder')"
          :dropdown-style="{ zIndex: drawerZIndex + 100 }"
          :get-popup-container="getSelectPopupContainer"
        >
          <a-select-option
            v-for="opt in auditStatusOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <template v-if="showAuditReasonFields">
        <a-form-model-item :label="$t('views.settlementPayment.form.auditReason')" prop="auditReason">
          <a-input
            v-model="form.auditReason"
            :placeholder="$t('views.settlementPayment.form.auditReasonPlaceholder')"
            type="textarea"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('views.settlementPayment.form.auditReasonEn')" prop="auditReasonEn">
          <a-input
            v-model="form.auditReasonEn"
            :placeholder="$t('views.settlementPayment.form.auditReasonEnPlaceholder')"
            type="textarea"
            allow-clear
          />
        </a-form-model-item>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.settlementPayment.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.settlementPayment.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSettlementPayment, addSettlementPayment, updateSettlementPayment } from '@/api/user/settlementPayment'

export default {
  name: 'CreateForm',
  props: {
    /** 嵌入外层抽屉时提高层级，避免被父级 Drawer 挡住 */
    drawerZIndex: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      auditMode: false,
      form: {
        id: null,
        settlementId: null,
        type: null,
        money: null,
        url: null,
        auditStatus: 1,
        auditReason: null,
        auditReasonEn: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {}
    }
  },
  computed: {
    paymentTypeOptions () {
      return [
        { value: 0, label: this.$t('views.settlementPayment.paymentType.full') },
        { value: 1, label: this.$t('views.settlementPayment.paymentType.first') },
        { value: 2, label: this.$t('views.settlementPayment.paymentType.final') }
      ]
    },
    auditStatusOptions () {
      return [
        { value: 0, label: this.$t('views.settlementPayment.auditStatus.pending') },
        { value: 1, label: this.$t('views.settlementPayment.auditStatus.approved') },
        { value: 2, label: this.$t('views.settlementPayment.auditStatus.rejected') }
      ]
    },
    urlPreviewList () {
      const u = this.form.url
      if (u == null || u === '') {
        return []
      }
      return String(u)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    },
    /** 审核模式：结算信息只读（与订单付款审核表单一致） */
    baseFieldsDisabled () {
      return this.auditMode
    },
    /** 仅审核驳回(2)时展示中英文审核原因 */
    showAuditReasonFields () {
      const v = this.form && this.form.auditStatus
      return Number(v) === 2
    }
  },
  watch: {
    'form.auditStatus' (val) {
      if (Number(val) !== 2) {
        this.form.auditReason = null
        this.form.auditReasonEn = null
      }
    }
  },
  methods: {
    /** 下拉挂在当前抽屉内，避免被父级 Drawer 遮挡；无抽屉时退回 body */
    getSelectPopupContainer (triggerNode) {
      if (!triggerNode || !triggerNode.closest) {
        return document.body
      }
      const drawerBody = triggerNode.closest('.ant-drawer-body')
      return drawerBody || document.body
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.auditMode = false
      this.form = {
        id: null,
        settlementId: null,
        type: null,
        money: null,
        url: null,
        auditStatus: 1,
        auditReason: null,
        auditReasonEn: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 详情接口若返回蛇形 audit_reason_en，合并到 camelCase 并去掉多余字段 */
    normalizeDetailFromApi () {
      if (this.form.audit_reason_en != null && (this.form.auditReasonEn == null || this.form.auditReasonEn === '')) {
        this.form.auditReasonEn = this.form.audit_reason_en
      }
      if (Object.prototype.hasOwnProperty.call(this.form, 'audit_reason_en')) {
        delete this.form.audit_reason_en
      }
    },
    normalizeNumericFields () {
      if (this.form.type !== null && this.form.type !== undefined && this.form.type !== '') {
        const n = Number(this.form.type)
        this.form.type = Number.isNaN(n) ? this.form.type : n
      }
      if (this.form.auditStatus === null || this.form.auditStatus === undefined || this.form.auditStatus === '') {
        this.form.auditStatus = 1
      } else {
        const a = Number(this.form.auditStatus)
        this.form.auditStatus = Number.isNaN(a) ? 1 : a
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.settlementPayment.form.titleAdd')
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.auditMode = false
      const id = row ? row.id : ids
      getSettlementPayment({ id }).then(response => {
        const payload = response && (response.data !== undefined && response.data !== null ? response.data : response)
        this.form = { ...this.form, ...payload }
        this.normalizeDetailFromApi()
        this.normalizeNumericFields()
        this.open = true
        this.formTitle = this.$t('views.settlementPayment.form.titleEdit')
      }).catch(() => {
        this.$message.error(this.$t('views.settlementPayment.msg.detailFail'))
      })
    },
    /** 待审核列表「审核」入口：只读结算/金额/截图，可改审核状态与原因 */
    handleAudit (row) {
      this.reset()
      this.formType = 2
      this.auditMode = true
      getSettlementPayment({ id: row.id }).then(response => {
        const payload = response && (response.data !== undefined && response.data !== null ? response.data : response)
        this.form = { ...this.form, ...payload }
        this.normalizeDetailFromApi()
        this.normalizeNumericFields()
        /** 审核入口：默认选中审核通过，可再改为待审核/驳回 */
        this.form.auditStatus = 1
        this.open = true
        this.formTitle = this.$t('views.settlementPayment.form.titleAudit')
      }).catch(() => {
        this.$message.error(this.$t('views.settlementPayment.msg.detailFail'))
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        if (this.form.id !== undefined && this.form.id !== null) {
          updateSettlementPayment(this.form).then(response => {
            if (response.success) {
              this.$message.success(this.$t('views.settlementPayment.msg.updateOk'), 3)
              this.open = false
              this.$emit('ok')
            } else {
              const messageInfo = response.message || response.msg || this.$t('views.settlementPayment.msg.updateFail')
              this.$message.error(messageInfo)
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          addSettlementPayment(this.form).then(response => {
            if (response.success) {
              this.$message.success(this.$t('views.settlementPayment.msg.addOk'), 3)
              this.open = false
              this.$emit('ok')
            } else {
              const messageInfo = response.message || response.msg || this.$t('views.settlementPayment.msg.addFail')
              this.$message.error(messageInfo)
            }
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
